import { useGame } from "providers/game-provider";
import { WorkoutCardProps } from "interfaces/components";
import { calcHitsAvgSpeedOver5sec } from "lib/speed";
import { calcTotalHitsForce } from "lib/utils";
import { useIntensity } from "lib/intensity";

const defaultUserWeight = 75

export default function withStats(Component: React.FC<WorkoutCardProps>) {
  return (props: any) => {
    const { hits } = props;
    if (!Array.isArray(hits)) throw new Error('hits must be an array');

    const hitsCount = hits.length
    const { currentCounter } = useGame()
    const avgSpeed = calcHitsAvgSpeedOver5sec(hits, currentCounter)
    const totalForce = Math.round(calcTotalHitsForce(hits))
    const avgIntensity = useIntensity(hits, defaultUserWeight, currentCounter)

    return (
      <Component
        {...props}
        hitsCount={hitsCount}
        totalForce={totalForce}
        avgIntensity={avgIntensity}
        avgSpeed={avgSpeed}
      />
    )
  }
}
